import React, { useState } from "react";
import { Loader2, X, Mic } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { liveDemoUrl } from "../mock";

/**
 * Opens the live voice-agent inside an in-app modal (iframe).
 * The underlying URL is never shown to the user and never opens a new tab.
 * `trigger` is the clickable element that opens the modal.
 */
const LiveDemoModal = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleOpenChange = (v) => {
    setOpen(v);
    if (v) setLoading(true);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <span onClick={() => handleOpenChange(true)} className="inline-flex">
        {trigger}
      </span>

      <DialogContent
        className="max-w-2xl overflow-hidden border-white/10 bg-[#04060a] p-0 text-white sm:rounded-2xl"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogTitle className="sr-only">Arkision AI Live Voice Agent</DialogTitle>

        <div className="flex items-center justify-between border-b border-white/10 bg-white/[0.03] px-5 py-3.5">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-cyan-400/15">
              <Mic className="h-4 w-4 text-cyan-300" />
            </div>
            <div>
              <div className="font-display text-sm font-semibold text-white">Arkision Live Voice Agent</div>
              <div className="flex items-center gap-1.5 text-xs text-slate-500">
                <span className="blink-dot h-1.5 w-1.5 rounded-full bg-emerald-400" /> Connected · Speak naturally
              </div>
            </div>
          </div>
          <button
            onClick={() => setOpen(false)}
            aria-label="Close demo"
            className="rounded-lg border border-white/10 p-1.5 text-slate-300 transition-colors hover:bg-white/5 hover:text-white"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="relative h-[520px] w-full bg-[#04060a]">
          {loading && (
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-[#04060a]">
              <Loader2 className="h-7 w-7 animate-spin text-cyan-300" />
              <span className="text-sm text-slate-400">Connecting to your AI agent…</span>
            </div>
          )}
          {open && (
            <iframe
              title="Arkision Live Voice Agent"
              src={liveDemoUrl}
              onLoad={() => setLoading(false)}
              allow="microphone; autoplay"
              className="h-full w-full border-0"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LiveDemoModal;
